import { useMutation, useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, Ingredient, INGREDIENT, Ingredients } from '@/core';

export const useIngredients = () => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${INGREDIENT}`;

  const useIngredientsQuery = useQuery<Ingredients>({
    queryKey: ['ingredients'],
    queryFn: () =>
      axiosInstance.get(fullUrl, { params: { page: 0, limit: 100 } }).then((res) => res.data),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: true,
    enabled: true,
  });

  const useIngredientsSearch = (search: string) =>
    useQuery<Ingredient[]>({
      queryKey: ['ingredientsSearch', search],
      queryFn: async () => {
        const response = await axiosInstance.get(`${fullUrl}/search`, { params: { name: search } });
        return response.data;
      },
    });

  const deleteIngredientMutation = useMutation({
    mutationKey: ['deleteProductQuiz'],
    mutationFn: (ingredientId: number) => axiosInstance.delete(`${fullUrl}/${ingredientId}`),
  });

  return {
    useIngredientsQuery,
    useIngredientsSearch,
    deleteIngredientMutation,
  };
};
